import icImageDefault from 'assets/images/ic-image-x.svg'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import { ACTION_TYPE } from 'constants/constant'
import { Button } from 'avo-ui'
import { setNumberWithPoint } from 'utils/utils'

export const TABLE_CATEGORY = {
    name: 'Category',
    column: [
        {
            name: 'Category',
            key: 'category',
            render: ({ item }) => (
                <div className={'flex flex-row gap-3 items-center'}>
                    <img className={'w-7 h-7'} src={item?.image_url || icImageDefault} alt={item?.name} />
                    <div className={'capitalize'}>{item?.name}</div>
                </div>
            ),
        },
        {
            name: 'Parent Category',
            key: 'parent',
            render: ({ value }) => <div>{value?.name ?? '-'}</div>,
        },
        {
            name: 'Slug',
            key: 'slug',
        },
        {
            name: 'Jumlah Produk',
            key: 'product_count',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button
                    type={'outline'}
                    title={'Edit'}
                    icon={icEditYellow}
                    onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
